import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var YachtChartersIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    d: "M16 28c2.812 0 5.496-1.097 7.497-3.031A10.672 10.672 0 0 0 31.005 28a1 1 0 1 0-.01-2 8.675 8.675 0 0 1-6.725-3.138 1 1 0 0 0-1.536-.004 8.79 8.79 0 0 1-13.468 0 1 1 0 0 0-1.534.002A8.73 8.73 0 0 1 1.002 26a1 1 0 0 0-.005 2 10.732 10.732 0 0 0 7.505-3.033C10.502 26.902 13.188 28 16 28zm0-9c2.812 0 5.496-1.097 7.497-3.031A10.672 10.672 0 0 0 31.005 19a1 1 0 1 0-.01-2 8.675 8.675 0 0 1-6.725-3.138 1 1 0 0 0-1.536-.004 8.79 8.79 0 0 1-13.468 0 1 1 0 0 0-1.534.002A8.73 8.73 0 0 1 1.002 17a1 1 0 0 0-.005 2 10.732 10.732 0 0 0 7.505-3.033C10.502 17.902 13.188 19 16 19zm.002-9A10.668 10.668 0 0 0 23.5 6.972 10.673 10.673 0 0 0 31.005 10a1 1 0 1 0-.01-2 8.675 8.675 0 0 1-6.725-3.138 1 1 0 0 0-1.54 0A8.675 8.675 0 0 1 16.005 8a8.741 8.741 0 0 1-6.737-3.14 1 1 0 0 0-1.536 0A8.73 8.73 0 0 1 1.002 8a1 1 0 0 0-.005 2A10.73 10.73 0 0 0 8.5 6.969c2 1.94 4.688 3.038 7.502 3.031z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});

export default YachtChartersIcon;
//# sourceMappingURL=yacht-charters.svg.js.map
